import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../data-storage.service';
import {BagElement} from '../../../models/bagElement';
import {ApiBagService} from '../../apiServices/bag/api-bag.service';

@Component({
  selector: 'app-mybag',
  templateUrl: './mybag.component.html',
  styleUrls: ['./mybag.component.scss']
})
export class MybagComponent implements OnInit {


  constructor(public dataStorageService: DataStorageService,
              private bagApi: ApiBagService) {
  }

  ngOnInit() {
  }

  uniqueTotal(): number {
    let cost = 0;
    this.dataStorageService.currentState.deviceBag.map(e => {
      cost += (e.device.salePrice * e.quantity);
    });
    if (this.dataStorageService.currentState.discount > 0) {
      const discountPrice = cost - Math.round(cost * (this.dataStorageService.currentState.discount * 0.01));
      return discountPrice;
    } else {
      return cost;
    }
  }

  getTaxes() {
    const tax = Math.round((this.uniqueTotal() * 0.077));
    return tax;
  }

  popupClick() {
    this.dataStorageService.devicePopup = false;
  }

  getSalePrice(myBagElement: BagElement): number {
    return myBagElement.device.salePrice * myBagElement.quantity;
  }

  removeItem(i: number) {
    const result = confirm('Are you sure to delete?');
    if (result) {
      this.bagApi.deleteBagDevice(this.dataStorageService.currentState.deviceBag[i].device.id)
        .then(() => this.dataStorageService.currentState.deviceBag.splice(i, 1));
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/content/mybag/mybag.component.ts